import { useEffect, useState } from "react";

//import material
import {
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Card,
  Paper,
  CardHeader,
  Typography,
  CardContent,
  Button,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  DialogActions,
  Divider,
  Stack,
  Box,
  useTheme,
  CircularProgress,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
//import config from "../../../../config";

//project components

import useAxiosAuth from "../../../../../hooks/useAxiosAuth";
import SubSpecializationForm from "./SubSpecializationForm";
import NoDataFound from "../../../../../components/NoDataFound";

const SubSpecialization = (props) => {
  //Constants
  const axiosAuth = useAxiosAuth();
  const pageSize = 100;
  const theme = useTheme();
  const { selectedSpecializationId } = props;
  console.log("selectedSpecializationId", selectedSpecializationId);
  //States
  const [employerSubSpecializations, setEmployerSubSpecializations] = useState(
    []
  );
  const [openAdd, setOpenAdd] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [showActions, setShowActions] = useState(false);
  const [loading, setLoading] = useState(false);
  const [
    selectedEmployerSubSpecializations,
    setSelectedEmployerSubSpecializations,
  ] = useState({
    id: 0,
    name: "",
  });

  const handleAdd = () => {
    setSelectedEmployerSubSpecializations({
      id: 0,
      name: "",
    });
    setOpenAdd(true);
  };
  //Methods
  const getEmployerSubSpecializations = (skip) => {
    if (!selectedSpecializationId) return;

    setLoading(true);
    axiosAuth
      .get(
        "/api/EmployerSubSpecializationMasters/by-employer-specialization?employerSpecializationId=" +
          selectedSpecializationId
      )
      .then((response) => {
        setEmployerSubSpecializations(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };
  const handleDelete = () => {
    setLoading(true);
    axiosAuth
      .delete(
        "/api/EmployerSubSpecializationMasters/" +
          selectedEmployerSubSpecializations.id
      )
      .then((response) => {
        //onSave();
        setOpenDelete(false);
        getEmployerSubSpecializations();
      })
      .catch((error) => {
        console.log(error);
        setOpenDelete(false);
        setLoading(false);
      });
  };
  const handleSave = () => {
    // onSave();
    setOpenAdd(false);
  };
  const handleCancel = () => {
    setOpenAdd(false);
  };
  const handleCancelDelete = () => {
    setOpenDelete(false);
  };
  useEffect(() => {
    getEmployerSubSpecializations();
  }, [selectedSpecializationId]);
  console.log("employerSubSpecializations", employerSubSpecializations);
  return (
    <>
      <Grid container direction="row" spacing={2}>
        <Grid item xs={12} sm={12} md={12}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
          >
            <Typography variant="h6"> Sub Specializations/Products</Typography>
            {/* </Grid>
        <Grid item> */}
            <IconButton
              onClick={handleAdd}
              disabled={!selectedSpecializationId}
            >
              <AddIcon />
            </IconButton>
          </Stack>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Card
            variant="outlined"
            sx={{
              backgroundColor: theme.palette.grey[50],
              borderRadius: 2,
              padding: 1,
              minHeight: 100, // Add minimum height to prevent layout shift
            }}
          >
            {loading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: 200,
                }}
              >
                <Stack
                  direction="column"
                  spacing={2}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Typography variant="body1">
                    Loading sub-specializations...
                  </Typography>
                  <CircularProgress />
                </Stack>
              </Box>
            ) : !selectedSpecializationId ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: 100,
                }}
              >
                <Typography variant="body1" color="text.secondary">
                  Please select a specialization to view sub-specializations
                </Typography>
              </Box>
            ) : Array.isArray(employerSubSpecializations) &&
              employerSubSpecializations.length === 0 ? (
              <Grid item xs={12}>
                <NoDataFound />
              </Grid>
            ) : (
              employerSubSpecializations.map((specialization, index) => {
                return (
                  <Card
                    key={specialization.id}
                    variant="outlined"
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderRadius: 2,
                      padding: 1,
                      marginBottom: 1,
                    }}
                  >
                    <CardContent sx={{ flex: 1, padding: 0 }}>
                      <Typography variant="subtitle1" noWrap>
                        {specialization.name}
                      </Typography>
                    </CardContent>

                    <IconButton
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        setSelectedEmployerSubSpecializations(specialization);
                        setOpenAdd(true);
                      }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                      color="error"
                      onClick={() => {
                        setSelectedEmployerSubSpecializations(specialization);
                        setOpenDelete(true);
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Card>
                );
              })
            )}
          </Card>
        </Grid>
      </Grid>

      <Dialog open={openAdd} onClose={handleCancel} fullWidth>
        <DialogContent>
          <SubSpecializationForm
            onSave={handleSave}
            onCancel={handleCancel}
            selectedEmployerSubSpecializations={
              selectedEmployerSubSpecializations
            }
            getEmployerSubSpecializations={getEmployerSubSpecializations}
          />
        </DialogContent>
      </Dialog>
      <Dialog open={openDelete} onClose={handleCancelDelete} fullWidth>
        <DialogTitle>Delete Employer SubSpecialization</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the employer subspecialization of{" "}
            <span style={{ color: "#E90000" }}>
              {selectedEmployerSubSpecializations.name}
            </span>
            ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDelete} variant="contained">
            Yes
          </Button>
          <Button onClick={handleCancelDelete} variant="outlined">
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SubSpecialization;
